import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import {
  FETCH_AIR_BRAKE_PARAMS,
  FETCH_FLOOR_PVC_PARAMS,
  FETCH_FURNISHING_QCI_PARAMS,
  FETCH_FURNISHING_TESTING_BIOTOILET_PARAMS,
  FETCH_FURNISHING_TESTING_FIRE_PARAMS,
  FETCH_LAVATORY_PARAMS,
  FETCH_MOULDING_DOOR_PARAMS,
  FETCH_PANELLING_PARAMS,
  FETCH_PARTITION_PARAMS,
  FETCH_PLUMBING_PARAMS,
  FETCH_SEAT_BERTH_PARAMS,
  FETCH_WINDOW_CEILING_PARAMS,
  ADD_FLOOR_PVC,
  LIST_FLOOR_PVC,
  VIEW_FLOOR_PVC,
  ADD_PARTITION,
  VIEW_PARTITION,
  LIST_PARTITION,
  LIST_AIR_BRAKE,
  VIEW_AIR_BRAKE,
  SAVE_AIR_BRAKE,
  VIEW_PLUMBING,
  LIST_PLUMBING,
  SAVE_PLUMBING,
  VIEW_MOULDING_DOOR,
  LIST_MOULDING_DOOR,
  SAVE_MOULDING_DOOR,
  FETCH_WINDOW_CEILING_LIST,
  STORE_WINDOW_CEILING,
  VIEW_WINDOW_CEILING,
  CHECK_WINDOW_CEILING_DUPLICATE,
  DELETE_WINDOW_CEILING,
  FETCH_BUFFER_CBC_PARAMS,
  FETCH_TESTING_LEAKAGE_PARAMS,
  FETCH_TESTING_AIR_BRAKE_PARAMS,
  ADD_PANNELING,
  LIST_PANNELING,
  VIEW_PANNELING,
  UPDATE_ALL_ONE_ACTION_LATEST,
  FURNISING_MODULINGDOOR_FLOW_HISTROY,
  FURNISING_PUMBLING_FLOW_HISTROY,
  FURNISING_AIR_BRAKE_FLOW_HISTROY,
  GET_FURNISHING_SHELL_NO,
  STORE_SEAT_BERTH,
  FETCH_SEAT_BERTH_LIST,
  VIEW_SEAT_BERTH,
  CHECK_SEAT_BERTH_DUPLICATE,
  STORE_LAVATORY,
  FETCH_LAVATORY_LIST,
  VIEW_LAVATORY,
  CHECK_LAVATORY_DUPLICATE,
  UPDATE_FURNISHING_STATUS,
  GET_FURNISHING_FLOW_HISTORY,
  CHECK_FURNISHING_DUPLICATE,
  GET_FURNISHING_HISTORY_FLOW,
  UPDATE_FURNISHING_FLOW,
  STORE_FIRE_DETECTION,
  LIST_FIRE_DETECTION,
  VIEW_FIRE_DETECTION,
  STORE_BIOTOILET,
  LIST_BIOTOILET,
  TESTING_FIBA_PARAMS,
  VIEW_BIOTOILET,
  STORE_LEAKAGE,
  LIST_LEAKAGE,
  VIEW_LEAKAGE,
  FETCH_TESTING_BUFFER_CBC_OBS_PARAMS,
  FURNISHING_QCI_COMPLETED_STAGES,
  DELETE_FURNISHING_QCI,
  FURNISHING_QCI_FLOW_HISTORY,
  VIEW_FURNISHING_QCI_STAGE,
  VIEW_FURNISHING_QCI_ASSEMBLY,
  LIST_FURNISHING_QCI,
  STORE_FUNISHING_QCI_DATA,
  FIRE_FLOW_HISTORY,
  LEAKAGE_FLOW_HISTORY,
  UPDATE_FIRE_FLOW_STATUS,
  UPDATE_LEAKAGE_FLOW_STATUS,
  UPDATE_BIOTOILET_FLOW_STATUS,
  BIOTOILET_FLOW_HISTORY,
  CHECK_RECORD_EXIST,
  CHECK_PVC_TYPE_EXIST,
  // UPDATE_FLOOR_PVC_ACTION,
  VIEW_FLOOR_PVC_ASSEMBLY,
  VIEW_FLOOR_PVC_STAGE,
  FLOOR_PVC_FLOW_HISTORY,
  TAKE_ACTION_FLOOR_PVC,
  TAKE_ACTION_WINDOW_CEILING,
  VIEW_WINDOW_CEILING_STAGE,
  WINDOW_CEILING_FLOW_HISTORY,
  DELETE_STAGE_AUDIT_DELETE,
  FETCH_ROOM_TYPES,
  IC_DOORS_LIST,
  GET_IC_DOOR_FORM_PARAMS,
  FURNISHING_QCI_FETCHED_LATSET_STAGES,
  VIEW_FLOORBOARD,
  GET_DCOUPLING_PARAMS,
  LIST_FLOORBOARD,
  FETCH_FLOORBOARD_PARAMS,
  ADD_SAF_FLOORPVC,
  FETCH_SAF_FLOOR_PVC_PARAMS,
  VIEW_SAF_FLOORPVC,
  STORE_FLOORBOARD,
  UPDATE_STATUS_FLOORBOARD,
  GET_PLUGDOOR_PARAMS,
  IC_DOORS_STORE,
  IC_DOORS_FLOW_HISTORY,
  IC_DOORS_VIEW_DATA,
  IC_UPDATE_FLOW_STATUS,
  FETCH_GANGWAY_PARAMS,
  FETCH_GLASSWOOL_PARAMS,
  FETCH_SAFWINDOW_PARAMS,
  FETCH_SAFPARTITION_PARAMS,
  STORE_DCOUPLING_PARAMS,
  DCOUPLING_LIST,
  DCOUPLING_VIEW,
  FURNISING_DCOUPLING_FLOW_HISTROY,
  GET_ACDUCT_PARAMS,
  STORE_ACDUCT_PARAMS,
  STORE_UPDATE_PLUGDOOR,
  LISTING_PLUGDOOR,
  PLUGDOOR_DELETE,
  PLUGDOOR_FLOW_HISTORY,
  PLUGDOOR_UPDATE_FLOW_STATUS,
  HISTORY_FLOORBOARD,
  LIST_SAF_FLOORPVC,
  UPDATE_VB_FLOORPVC_STATUS,
  HISTORY_VB_FLOORPVC,
  DELETE_FLOORBOARD,
  DELETE_VB_FLOORPVC,
  LIST_GLASS_WOOL,
  VIEW_GLASS_WOOL,
  STORE_GLASS_WOOL,
  UPDATE_GLASS_WOOL_STATUS,
  GET_LUGGAGE_RACK_PARAMS,
  GET_SEAT_PARAMS,
  STORE_GANGWAY_PARAMS,
  FETCH_GANGWAY_LIST,
  GANGWAY_VIEW,
  FURNISING_GANGWAY_FLOW_HISTROY,
  FETCH_GLASS_WOOL_HISTORY,
  DELETE_GLASS_WOOL,
  FETCH_VB_AIRBRAKE_PARAMS,
  STORE_AC_DUCT,
  LIST_AC_DUCT,
  VIEW_AC_DUCT,
  UPDATE_AC_DUCT_STATUS,
  DELETE_AC_DUCT,
  FETCH_AC_DUCT_HISTORY,
  FURNISING_WINDOW_FLOW_HISTROY,
  WINDOW_VIEW,
  FETCH_WINDOW_LIST,
  STORE_WINDOW_PARAMS,
  FETCH_LAVATORY_VB_PARAMS,
  FETCH_PANELLING_VB_PARAMS,
  STORE_LUGGAGE_RACK,
  LIST_LUGGAGE_RACK,
  LUGGAGE_RACK_DELETE,
  GET_LUGGAGE_RACK_FLOW_HISTORY,
  UPDATE_LUGGAGE_RACK_FLOW_STATUS,
  STORE_VB_PANELLING_PARAMS,
  FETCH_VB_PANEL_LIST,
  VB_PANEL_VIEW,
  FURNISING_VB_PANEL_FLOW_HISTROY,
  STORE_VB_LAVATORY_PARAMS,
  FETCH_VB_LAVATORY_LIST,
  VB_LAVATORY_VIEW,
  FURNISING_VB_LAVATORY_FLOW_HISTROY,
  STORE_PARTITION_PARAMS,
  FETCH_PARTITION_LIST,
  PARTITION_VIEW,
  FURNISHING_PARTITION_FLOW_HISTORY,
  STORE_SEAT_INSPECTION_VB,
  FETCH_SEAT_INSPECTION_VB_LIST,
  VIEW_SEAT_INSPECTION_VB,
  SEAT_INSPECTION_VB_FLOW_HISTORY,
  STORE_UPDATE_VB_BIOTOILET,
  FETCH_VB_BIOTOILET_LIST,
  DELETE_VB_BIOTOILET,
  UPDATE_VB_BIOTOILET_FLOW_STATUS,
  GET_VB_BIOTOILET_FLOW_HISTORY,
  VIEW_VB_BIOTOILET_FLOW_HISTORY,
  STORE_AIRBRAKE_TEST_VB,
  FETCH_AIRBRAKE_TEST_VB_LIST,
  VIEW_AIRBRAKE_TEST_VB,
  AIRBRAKE_TEST_VB_FLOW_HISTORY,
  GET_TRACTION_PARAMS,
  CHECK_FURNISHING_RECORD_EXIST,
  GET_BRAKE_EQUIPMENT_SUPPLIERS,
  GET_INSTALLED_BY,
  PARTITION_FLOW_HISTORY,
  PANNELING_FLOW_HISTORY,
} from '../../../api/apiConstant';

export const fetchRoomTypes = createAsyncThunk(
  'furnishing/fetchRoomTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_ROOM_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchFloorPvcParams = createAsyncThunk(
  'furnishing/fetchFloorPvcParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_FLOOR_PVC_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchPartitionParams = createAsyncThunk(
  'furnishing/fetchPartitionParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_PARTITION_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchPanellingParams = createAsyncThunk(
  'furnishing/fetchPanellingParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_PANELLING_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchSeatAndBerthParams = createAsyncThunk(
  'furnishing/fetchSeatAndBerthParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_SEAT_BERTH_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchLavatoryParams = createAsyncThunk(
  'furnishing/fetchLavatoryParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_LAVATORY_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchTestingAirBrakeParams = createAsyncThunk(
  'furnishing/fetchTestingAirBrakeParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_TESTING_AIR_BRAKE_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchTestingFibaParams = createAsyncThunk(
  'furnishing/fetchTestingFibaParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_FIBA_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
export const fetchPlumbingParams = createAsyncThunk(
  'furnishing/fetchPlumbingParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_PLUMBING_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchAirBrakeParams = createAsyncThunk(
  'furnishing/fetchAirBrakeParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_AIR_BRAKE_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchWindowCellingParams = createAsyncThunk(
  'furnishing/fetchWindowCellingParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_WINDOW_CEILING_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchMouldingDoorParams = createAsyncThunk(
  'furnishing/fetchMouldingDoorParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_MOULDING_DOOR_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchFurnishingQciParams = createAsyncThunk(
  'furnishing/fetchFurnishingQciParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_FURNISHING_QCI_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchFurnishingTestingFireParams = createAsyncThunk(
  'furnishing/fetchFurnishingTestingFireParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_FURNISHING_TESTING_FIRE_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchFurnishingTestingBiotoiletParams = createAsyncThunk(
  'furnishing/fetchFurnishingTestingBiotoiletParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_FURNISHING_TESTING_BIOTOILET_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchBufferCbcParams = createAsyncThunk(
  'furnishing/fetchBufferCbcParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_BUFFER_CBC_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchTestingBufferCbcObsparams = createAsyncThunk(
  'furnishing/fetchTestingBufferCbcObsparams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_TESTING_BUFFER_CBC_OBS_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchTestingLeakageParams = createAsyncThunk(
  'furnishing/fetchTestingLeakageParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_TESTING_LEAKAGE_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const addFloorPvc = createAsyncThunk(
  'furnishing/addFloorPvc',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_FLOOR_PVC, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add floor and pvc inspection data',
      );
    }
  },
);

export const listFloorPvc = createAsyncThunk(
  'furnishing/listFloorPvc',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_FLOOR_PVC, {
        params,
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const fetchviewFloorPvc = createAsyncThunk(
  'furnishing/fetchviewFloorPvc',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FLOOR_PVC, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floor and pvc',
      );
    }
  },
);

export const addPartition = createAsyncThunk(
  'furnishing/addPartition',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_PARTITION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add partition inspection data',
      );
    }
  },
);

export const listPartition = createAsyncThunk(
  'furnishing/listPartition',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_PARTITION, {
        params,
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const fetchviewPartition = createAsyncThunk(
  'furnishing/fetchviewPartition',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_PARTITION, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view partition',
      );
    }
  },
);
export const saveMouldingDoor = createAsyncThunk(
  'furnishing/saveMouldingDoor',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(SAVE_MOULDING_DOOR, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
export const fetchMouldingDoorList = createAsyncThunk(
  'furnishing/fetchMouldingDoorList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_MOULDING_DOOR, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchMouldingDoorById = createAsyncThunk(
  'furnishing/fetchMouldingDoorById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_MOULDING_DOOR, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const savePlumbing = createAsyncThunk(
  'furnishing/savePlumbing',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(SAVE_PLUMBING, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchPlumbingList = createAsyncThunk(
  'furnishing/fetchPlumbingList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_PLUMBING, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchPlumbingById = createAsyncThunk(
  'furnishing/fetchPlumbingById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_PLUMBING, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const saveAirBrake = createAsyncThunk(
  'furnishing/saveAirBrake',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(SAVE_AIR_BRAKE, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchAirBrakeList = createAsyncThunk(
  'furnishing/fetchAirBrakeList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_AIR_BRAKE, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchAirBrakeById = createAsyncThunk(
  'furnishing/fetchAirBrakeById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_AIR_BRAKE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Window & Ceiling Data
export const storeWindowCeilingData = createAsyncThunk(
  'furnishing/storeWindowCeilingData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_WINDOW_CEILING, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Get Window & Ceiling List
export const fetchWindowCeilingList = createAsyncThunk(
  'furnishing/fetchWindowCeilingList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_WINDOW_CEILING_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// View Window & Ceiling
export const viewWindowCeilingData = createAsyncThunk(
  'furnishing/viewWindowCeilingData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${VIEW_WINDOW_CEILING}?id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Delete Window & Ceiling
export const deleteWindowCeilingData = createAsyncThunk(
  'furnishing/deleteWindowCeilingData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_WINDOW_CEILING}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Check Duplicate
export const checkWindowCeilingDuplicate = createAsyncThunk(
  'furnishing/checkWindowCeilingDuplicate',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(CHECK_WINDOW_CEILING_DUPLICATE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const mouldingDoorInspectionAction = createAsyncThunk(
  'furnishing/mouldingDoorInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchMouldingDoorFlowHistory = createAsyncThunk(
  'furnishing/fetchMouldingDoorFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_MODULINGDOOR_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchPlumbingFlowHistory = createAsyncThunk(
  'furnishing/fetchPlumbingFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_PUMBLING_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const plumbingInspectionAction = createAsyncThunk(
  'furnishing/mouldingDoorInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const airBrakeFlowHistory = createAsyncThunk(
  'furnishing/airBrakeFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_AIR_BRAKE_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const airBrakeInspectionAction = createAsyncThunk(
  'furnishing/airBrakeInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

//panneling

export const addPanneling = createAsyncThunk(
  'furnishing/addPanneling',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_PANNELING, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add panneling inspection data',
      );
    }
  },
);

export const listPanneling = createAsyncThunk(
  'furnishing/listPanneling',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_PANNELING, {
        params,
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const fetchviewPanneling = createAsyncThunk(
  'furnishing/fetchviewPanneling',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_PANNELING, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view panneling',
      );
    }
  },
);

export const fetchShellNo = createAsyncThunk(
  'furnishing/fetchShellNo',
  async (params, { rejectWithValue }) => {
    try {
      console.log('Shell API Params------------------:', params);

      const response = await api.get(GET_FURNISHING_SHELL_NO, {
        params,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// ==================== SEAT & BERTH ====================

// Store/Update Seat & Berth Data
export const storeSeatBerthData = createAsyncThunk(
  'furnishing/storeSeatBerthData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_SEAT_BERTH, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Get Seat & Berth List
export const fetchSeatBerthList = createAsyncThunk(
  'furnishing/fetchSeatBerthList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SEAT_BERTH_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// View Seat & Berth
export const viewSeatBerthData = createAsyncThunk(
  'furnishing/viewSeatBerthData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${VIEW_SEAT_BERTH}?id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Check Duplicate
export const checkSeatBerthDuplicate = createAsyncThunk(
  'furnishing/checkSeatBerthDuplicate',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(CHECK_SEAT_BERTH_DUPLICATE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// ==================== LAVATORY ====================

// Store/Update Lavatory Data
export const storeLavatoryData = createAsyncThunk(
  'furnishing/storeLavatoryData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_LAVATORY, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Get Lavatory List
export const fetchLavatoryList = createAsyncThunk(
  'furnishing/fetchLavatoryList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_LAVATORY_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// View Lavatory
export const viewLavatoryData = createAsyncThunk(
  'furnishing/viewLavatoryData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${VIEW_LAVATORY}?id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Check Duplicate
export const checkLavatoryDuplicate = createAsyncThunk(
  'furnishing/checkLavatoryDuplicate',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(CHECK_LAVATORY_DUPLICATE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Common Furnishing Status Update
export const updateFurnishingStatus = createAsyncThunk(
  'furnishing/updateFurnishingStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_FURNISHING_STATUS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Common Furnishing Flow History
export const fetchFurnishingFlowHistory = createAsyncThunk(
  'furnishing/fetchFurnishingFlowHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_FURNISHING_FLOW_HISTORY, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Common Furnishing Duplicate Check
export const checkFurnishingDuplicate = createAsyncThunk(
  'furnishing/checkFurnishingDuplicate',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(CHECK_FURNISHING_DUPLICATE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchFurnishingHistoryFlow = createAsyncThunk(
  'furnishing/fetchFurnishingHistoryFlow',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_FURNISHING_HISTORY_FLOW, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch history');
    }
  },
);

export const updateFlowStatus = createAsyncThunk(
  'furnishing/updateFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_FURNISHING_FLOW, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update flow data',
      );
    }
  },
);

//ADD FIRE
export const addTestingFire = createAsyncThunk(
  'furnishing/addTestingFire',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_FIRE_DETECTION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add testing fire data',
      );
    }
  },
);

export const listTestingFire = createAsyncThunk(
  'furnishing/listTestingFire',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_FIRE_DETECTION, {
        params
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const fetchviewFire = createAsyncThunk(
  'furnishing/fetchviewFire',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FIRE_DETECTION, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch view fire');
    }
  },
);

// export const addBiotoilet = createAsyncThunk(
//   'furnishing/addBiotoilet',
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await api.post(STORE_BIOTOILET, data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message ||
//           error.response?.data ||
//           error.message ||
//           'Failed to add biotoilet data',
//       );
//     }
//   },
// );
export const addBiotoilet = createAsyncThunk(
  'furnishing/addBiotoilet',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_BIOTOILET, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add biotoilet data',
      );
    }
  },
);
export const listBiotoilet = createAsyncThunk(
  'furnishing/listBiotoilet',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_BIOTOILET, {
        params
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const fetchViewBiotoilet = createAsyncThunk(
  'furnishing/fetchViewBiotoilet',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_BIOTOILET, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view biotoilet',
      );
    }
  },
);

export const addLeakage = createAsyncThunk(
  'furnishing/addBiotoilet',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_LEAKAGE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add biotoilet data',
      );
    }
  },
);

export const listLeakage = createAsyncThunk('furnishing/listLeakage', async (params, thunkAPI) => {
  try {
    const response = await api.get(LIST_LEAKAGE, {params
      // params: {
      //   page: params.page,
      //   perPage: params.perPage,
      //   date: params.date,
      //   shell_no: params.shell_no,
      //   search: params.search,
      // },
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data);
  }
});

export const fetchviewLeakage = createAsyncThunk(
  'furnishing/fetchviewLeakage',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_LEAKAGE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view leakage',
      );
    }
  },
);

export const saveFurnishingQciData = createAsyncThunk(
  'furnishing/saveFurnishingQciData',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_FUNISHING_QCI_DATA, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchFurnishingQciList = createAsyncThunk(
  'furnishing/fetchFurnishingQciList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_FURNISHING_QCI, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const viewFurnishingQciAssembly = createAsyncThunk(
  'furnishing/viewFurnishingQciAssembly',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FURNISHING_QCI_ASSEMBLY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchFurnishingQciStageById = createAsyncThunk(
  'furnishing/fetchFurnishingQciStageById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FURNISHING_QCI_STAGE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const furnishingQciInspectionAction = createAsyncThunk(
  'furnishing/furnishingQciInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, {
        ...formData,
        stage: 'furnishing_qci',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchFurnishingQciFlowHistory = createAsyncThunk(
  'furnishing/fetchFurnishingQciFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISHING_QCI_FLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteFurnishingQci = createAsyncThunk(
  'furnishing/deleteFurnishingQci',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_FURNISHING_QCI, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Delete failed');
    }
  },
);

export const fetchFurnishingQciCompletedStages = createAsyncThunk(
  'furnishing/fetchFurnishingQciCompletedStages',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISHING_QCI_COMPLETED_STAGES, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchFireHistoryFlow = createAsyncThunk(
  'furnishing/fetchFireHistoryFlow',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FIRE_FLOW_HISTORY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch history');
    }
  },
);

export const fetchLeakageHistoryFlow = createAsyncThunk(
  'furnishing/fetchLeakageHistoryFlow',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(LEAKAGE_FLOW_HISTORY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch history');
    }
  },
);

export const updateFireFlowStatus = createAsyncThunk(
  'furnishing/updateFireFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_FIRE_FLOW_STATUS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update flow data',
      );
    }
  },
);

export const updateLeakageFlowStatus = createAsyncThunk(
  'furnishing/updateLeakageFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_LEAKAGE_FLOW_STATUS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update flow data',
      );
    }
  },
);
export const furnishingQciAssemblyAction = createAsyncThunk(
  'boggie/furnishingQciAssemblyAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const checkExistRecord = createAsyncThunk(
  'furnishing/checkExistRecord',
  async (params, { rejectWithValue }) => {
    try {
      console.log('Shell API Params------------------:', params);

      const response = await api.post(CHECK_RECORD_EXIST, params);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
export const updateBiotoiletFlowStatus = createAsyncThunk(
  'furnishing/updateBiotoiletFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_BIOTOILET_FLOW_STATUS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update flow data',
      );
    }
  },
);

export const fetchBiotoiletHistoryFlow = createAsyncThunk(
  'furnishing/fetchBiotoiletHistoryFlow',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(BIOTOILET_FLOW_HISTORY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch history');
    }
  },
);

export const fetchPvcTypeExists = createAsyncThunk(
  'furnishing/fetchPvcTypeExists',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(CHECK_PVC_TYPE_EXIST, { params: formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch pvc type exist',
      );
    }
  },
);

// // export const floorPvcInspectionAction = createAsyncThunk(
// //   'furnishing/floorPvcInspectionAction',
// //   async (formData, { rejectWithValue }) => {
// //     try {
// //       const response = await api.post(UPDATE_FLOOR_PVC_ACTION, {
// //         ...formData,
// //         stage: 'floor_pvc',
// //       });
// //       return response.data;
// //     } catch (error) {
// //       return rejectWithValue(error.response?.data || error.message);
// //     }
//   },
// );

export const viewFloorPvcAssembly = createAsyncThunk(
  'furnishing/viewFloorPvcAssembly',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FLOOR_PVC_ASSEMBLY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const viewFloorPvcStage = createAsyncThunk(
  'furnishing/viewFloorPvcStage',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FLOOR_PVC_STAGE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchFloorPvcFlowHistory = createAsyncThunk(
  'furnishing/fetchFloorPvcFlowHistory',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FLOOR_PVC_FLOW_HISTORY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const floorPvcInspectionAction = createAsyncThunk(
  'furnishing/floorPvcInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(TAKE_ACTION_FLOOR_PVC, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const takeActionWindowCeiling = createAsyncThunk(
  'furnishing/floorPvcInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(TAKE_ACTION_WINDOW_CEILING, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const viewWindowCeilingStage = createAsyncThunk(
  'furnishing/viewWindowCeilingStage',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_WINDOW_CEILING_STAGE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchWindowCeilingNonAcFlowHistory = createAsyncThunk(
  'furnishing/fetchWindowCeilingNonAcFlowHistory',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(WINDOW_CEILING_FLOW_HISTORY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const deleteStageAudit = createAsyncThunk(
  'furnishing/deleteStageAudit',
  async (formData, { rejectWithValue }) => {
    try {
      // console.log(1370,formData);
      const response = await api.post(DELETE_STAGE_AUDIT_DELETE, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

export const fetchIcDoorList = createAsyncThunk(
  'furnishing/fetchIcDoorList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(IC_DOORS_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const getIcFormParams = createAsyncThunk(
  'furnishing/getIcFormParams',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_IC_DOOR_FORM_PARAMS, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchFurnishingQciLastStageData = createAsyncThunk(
  'furnishing/fetchFurnishingQciLastStageData',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISHING_QCI_FETCHED_LATSET_STAGES, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// ic door store update
export const createUpdateIcDoor = createAsyncThunk(
  'furnishing/createUpdateIcDoor',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(IC_DOORS_STORE, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// ic door view flow history
export const fetchIcDoorFlowHistory = createAsyncThunk(
  'furnishing/fetchIcDoorFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${IC_DOORS_FLOW_HISTORY}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// ic door view flow history
export const viewIcDoorDetails = createAsyncThunk(
  'furnishing/viewIcDoorDetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${IC_DOORS_VIEW_DATA}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// ic door update flow status
export const updateIcDoorFlowStatus = createAsyncThunk(
  'furnishing/updateIcDoorFlowStatus',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(IC_UPDATE_FLOW_STATUS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchViewFloorBoard = createAsyncThunk(
  'furnishing/fetchViewFloorBoard',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FLOORBOARD, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorboard',
      );
    }
  },
);

export const getDcouplingParams = createAsyncThunk(
  'furnishing/getDcouplingParams',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_DCOUPLING_PARAMS, params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
export const listFloorBoard = createAsyncThunk(
  'furnishing/listFloorBoard',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_FLOORBOARD, {
        params,
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   coach_no: params.coach_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);
export const fetchFloorBoardParams = createAsyncThunk(
  'furnishing/fetchFloorBoardParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_FLOORBOARD_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchSafFloorPvcParams = createAsyncThunk(
  'furnishing/fetchSafFloorPvcParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_SAF_FLOOR_PVC_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const addSafFloorPvc = createAsyncThunk(
  'furnishing/addSafFloorPvc',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_SAF_FLOORPVC, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add partition inspection data',
      );
    }
  },
);
export const fetchViewSafFloorPvc = createAsyncThunk(
  'furnishing/fetchViewSafFloorPvc',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_SAF_FLOORPVC, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

export const storeFloorBoard = createAsyncThunk(
  'furnishing/storeFloorBoard',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_FLOORBOARD, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const updateStatusFloorBoard = createAsyncThunk(
  'furnishing/updateStatusFloorBoard',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_STATUS_FLOORBOARD, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchPlugDoorParams = createAsyncThunk(
  'furnishing/fetchPlugDoorParams',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_PLUGDOOR_PARAMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch plugdoor parameters',
      );
    }
  },
);

// Gangway

export const fetchGangwayParams = createAsyncThunk(
  'furnishing/fetchGangwayParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_GANGWAY_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const addDCoupling = createAsyncThunk(
  'furnishing/addDCoupling',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_DCOUPLING_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

// Glasswool

export const fetchGlasswoolParams = createAsyncThunk(
  'furnishing/fetchGlasswoolParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_GLASSWOOL_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchListDcouplingData = createAsyncThunk(
  'furnishing/fetchListDcouplingData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(DCOUPLING_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

// SafWindow

export const fetchSafWindowParams = createAsyncThunk(
  'furnishing/fetchSafWindowParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_SAFWINDOW_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchDCouplingById = createAsyncThunk(
  'furnishing/fetchDCouplingById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DCOUPLING_VIEW, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

// SafPartition

export const fetchSafPartitionParams = createAsyncThunk(
  'furnishing/fetchSafPartitionParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_SAFPARTITION_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchDCouplingFlowHistory = createAsyncThunk(
  'furnishing/fetchDCouplingFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_DCOUPLING_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const getAcDuctParams = createAsyncThunk(
  'furnishing/getAcDuctParams',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_ACDUCT_PARAMS, params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const addAcDuctData = createAsyncThunk(
  'furnishing/addAcDuctData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_ACDUCT_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

export const storeUpdatePlugDoor = createAsyncThunk(
  'furnishing/storeUpdatePlugDoor',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_UPDATE_PLUGDOOR, formData);
      console.log('formdata from thunk', formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);
export const fetchFloorBoardHistory = createAsyncThunk(
  'furnishing/fetchFloorBoardHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(HISTORY_FLOORBOARD, {
        params: {
          stage_id: params.stage_id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const listSafVbFloorBoard = createAsyncThunk(
  'furnishing/listSafVbFloorBoard',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_SAF_FLOORPVC, {
        params,
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   coach_no: params.coach_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const updateStatusVbFloorPvc = createAsyncThunk(
  'furnishing/updateStatusVbFloorPvc',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_VB_FLOORPVC_STATUS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchVbFloorPvcHistory = createAsyncThunk(
  'furnishing/fetchVbFloorPvcHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(HISTORY_VB_FLOORPVC, {
        params: {
          stage_id: params.stage_id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteFloorBoard = createAsyncThunk(
  'furnishing/deleteFloorBoard',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_FLOORBOARD, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

export const plugDoorListing = createAsyncThunk(
  'furnishing/plugDoorListing',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LISTING_PLUGDOOR,{params});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

export const plugDoorDelete = createAsyncThunk(
  'furnishing/plugDoorDelete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${PLUGDOOR_DELETE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

export const getPlugDoorFlowHistory = createAsyncThunk(
  'furnishing/getPlugDoorFlowHistory  ',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${PLUGDOOR_FLOW_HISTORY}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history details',
      );
    }
  },
);

export const updatePlugDoorFlowStatus = createAsyncThunk(
  'furnishing/updatePlugDoorFlowStatus',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(PLUGDOOR_UPDATE_FLOW_STATUS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history details',
      );
    }
  },
);
export const deleteVbFloorPvc = createAsyncThunk(
  'furnishing/deleteVbFloorPvc',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_VB_FLOORPVC, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

export const fetchLuggageRackParams = createAsyncThunk(
  'furnishing/fetchLuggageRackParams',
  async (params, { rejectWithValue }) => {
    try {
      // Send params to the API
      const response = await api.post(GET_LUGGAGE_RACK_PARAMS, params);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch luggage rack parameters',
      );
    }
  },
);
export const fetchSeatInspectionVBParams = createAsyncThunk(
  'furnishing/fetchSeatInspectionVBParams',
  async (params, { rejectWithValue }) => {
    try {
      // Send params to the API
      const response = await api.post(GET_SEAT_PARAMS, params);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch luggage rack parameters',
      );
    }
  },
);

export const addGangway = createAsyncThunk(
  'furnishing/addGangway',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_GANGWAY_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to save gangway');
    }
  },
);

export const fetchListGangwayData = createAsyncThunk(
  'furnishing/fetchListGangwayData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_GANGWAY_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

export const fetchGangwayById = createAsyncThunk(
  'furnishing/fetchGangwayById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GANGWAY_VIEW, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch gangway details',
      );
    }
  },
);

export const gangwayInspectionAction = createAsyncThunk(
  'furnishing/gangwayInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch gangway details',
      );
    }
  },
);

export const fetchGangwayFlowHistory = createAsyncThunk(
  'furnishing/fetchGangwayFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_GANGWAY_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const dCouplingInspectionAction = createAsyncThunk(
  'furnishing/dCouplingInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch gangway details',
      );
    }
  },
);

//glass wool

export const addGlassWool = createAsyncThunk(
  'furnishing/addGlassWool',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_GLASS_WOOL, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add glass wool inspection data',
      );
    }
  },
);
export const getViewGlassWool = createAsyncThunk(
  'furnishing/getViewGlassWool',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_GLASS_WOOL, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view glass wool',
      );
    }
  },
);

export const listGlassWool = createAsyncThunk(
  'furnishing/listGlassWool',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(LIST_GLASS_WOOL, {
        params,
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   shell_no: params.shell_no,
        //   coach_no: params.coach_no,
        //   search: params.search,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const updateGlassWoolStatus = createAsyncThunk(
  'furnishing/updateGlassWoolStatus',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_GLASS_WOOL_STATUS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchGlassWoolHistory = createAsyncThunk(
  'furnishing/fetchGlassWoolHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_GLASS_WOOL_HISTORY, {
        params: {
          stage_id: params.stage_id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteGlassWool = createAsyncThunk(
  'furnishing/deleteGlassWool',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_GLASS_WOOL, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

export const fetchVbAirbrakeParams = createAsyncThunk(
  'furnishing/fetchVbAirbrakeParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_VB_AIRBRAKE_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
//AC DUCT

export const addAcDuct = createAsyncThunk(
  'furnishing/addAcDuct',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_AC_DUCT, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add ac duct inspection data',
      );
    }
  },
);
export const getViewAcDuct = createAsyncThunk(
  'furnishing/getViewAcDuct',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_AC_DUCT, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view ac duct',
      );
    }
  },
);

export const listAcDuct = createAsyncThunk('furnishing/listAcDuct', async (params, thunkAPI) => {
  try {
    const response = await api.get(LIST_AC_DUCT, {
      params
      // params: {
      //   page: params.page,
      //   perPage: params.perPage,
      //   date: params.date,
      //   shell_no: params.shell_no,
      //   coach_no: params.coach_no,
      //   search: params.search,
      // },
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data);
  }
});

export const updateAcDuctStatus = createAsyncThunk(
  'furnishing/updateGlassWoolStatus',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_AC_DUCT_STATUS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchAcDuctHistory = createAsyncThunk(
  'furnishing/fetchAcDuctHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_AC_DUCT_HISTORY, {
        params: {
          stage_id: params.stage_id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteAcDuct = createAsyncThunk(
  'furnishing/deleteAcDuct',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_AC_DUCT, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

export const addWindow = createAsyncThunk(
  'furnishing/addWindow',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_WINDOW_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to save gangway');
    }
  },
);

export const fetchListWindowData = createAsyncThunk(
  'furnishing/fetchListWindowData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_WINDOW_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

export const fetchWindowById = createAsyncThunk(
  'furnishing/fetchWindowById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(WINDOW_VIEW, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch gangway details',
      );
    }
  },
);

export const windowInspectionAction = createAsyncThunk(
  'furnishing/windowInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch gangway details',
      );
    }
  },
);

export const fetchWindowFlowHistory = createAsyncThunk(
  'furnishing/fetchWindowFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_WINDOW_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchPanellingVBParams = createAsyncThunk(
  'furnishing/fetchPanellingVBParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_PANELLING_VB_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const fetchLavatoryVBParams = createAsyncThunk(
  'furnishing/fetchLavatoryVBParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_LAVATORY_VB_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);
export const addVbPanelling = createAsyncThunk(
  'furnishing/addVbPanelling',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_VB_PANELLING_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save vb panel data',
      );
    }
  },
);

// luggage rack
export const storeLuggageRack = createAsyncThunk(
  'furnishing/storeLuggageRack',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_LUGGAGE_RACK, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchLuggageRacklist = createAsyncThunk(
  'furnishing/fetchLuggageRacklist',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_LUGGAGE_RACK, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch luggage rack list',
      );
    }
  },
);
export const fetchListVbPanelData = createAsyncThunk(
  'furnishing/fetchListVbPanelData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_VB_PANEL_LIST, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view panel data',
      );
    }
  },
);

export const deleteLuggageRack = createAsyncThunk(
  'furnishing/deleteLuggageRack',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${LUGGAGE_RACK_DELETE}${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to delete luggage rack',
      );
    }
  },
);

export const fetchVbPanelById = createAsyncThunk(
  'furnishing/fetchVbPanelById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VB_PANEL_VIEW, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch gangway details',
      );
    }
  },
);

export const getLuggageRackFlowHistory = createAsyncThunk(
  'furnishing/getLuggageRackFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_LUGGAGE_RACK_FLOW_HISTORY}${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch luggage rack flow history',
      );
    }
  },
);

export const vbPanelInspectionAction = createAsyncThunk(
  'furnishing/vbPanelInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch gangway details',
      );
    }
  },
);

export const fetchVbPanelFlowHistory = createAsyncThunk(
  'furnishing/fetchVbPanelFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_VB_PANEL_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch vb panel history',
      );
    }
  },
);
export const addVbLavatory = createAsyncThunk(
  'furnishing/addVbLavatory',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_VB_LAVATORY_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save vb panel data',
      );
    }
  },
);

export const fetchListVbLavatoryData = createAsyncThunk(
  'furnishing/fetchListVbLavatoryData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_VB_LAVATORY_LIST, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch view floorpvc',
      );
    }
  },
);

export const fetchVbLavatoryById = createAsyncThunk(
  'furnishing/fetchVbLavatoryById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VB_LAVATORY_VIEW, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch lavatory details',
      );
    }
  },
);

export const vbLavatoryInspectionAction = createAsyncThunk(
  'furnishing/vbLavatoryInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch lavatory details',
      );
    }
  },
);

export const fetchVbLavatoryFlowHistory = createAsyncThunk(
  'furnishing/fetchVbLavatoryFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISING_VB_LAVATORY_FLOW_HISTROY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch vb lavatory history',
      );
    }
  },
);

export const addPartitionVB = createAsyncThunk(
  'furnishing/addPartition',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_PARTITION_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save partition VB',
      );
    }
  },
);

export const fetchListPartitionDataVB = createAsyncThunk(
  'furnishing/fetchListPartitionData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_PARTITION_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch partition VB list',
      );
    }
  },
);

export const fetchPartitionByIdVB = createAsyncThunk(
  'furnishing/fetchPartitionById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(PARTITION_VIEW, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch partition VB details',
      );
    }
  },
);

export const partitionInspectionActionVB = createAsyncThunk(
  'furnishing/partitionInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to update partition VB',
      );
    }
  },
);

export const fetchPartitionFlowHistoryVB = createAsyncThunk(
  'furnishing/fetchPartitionFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FURNISHING_PARTITION_FLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);

export const updateLuggageRackFlowStatus = createAsyncThunk(
  'furnishing/updateLuggageRackFlowStatus',
  async (formdata, { rejectWithValue }) => {
    console.log('formdata from thunk', formdata);
    try {
      const response = await api.post(`${UPDATE_LUGGAGE_RACK_FLOW_STATUS}${formdata.id}`, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to update luggage rack flow status',
      );
    }
  },
);

export const addSeatInspectionVB = createAsyncThunk(
  'furnishing/addSeatInspectionVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_SEAT_INSPECTION_VB, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save seat inspection VB',
      );
    }
  },
);

export const fetchListSeatInspectionVB = createAsyncThunk(
  'furnishing/fetchListSeatInspectionVB',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SEAT_INSPECTION_VB_LIST, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch seat inspection VB list',
      );
    }
  },
);

export const fetchSeatInspectionVBById = createAsyncThunk(
  'furnishing/fetchSeatInspectionVBById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_SEAT_INSPECTION_VB, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch seat inspection VB details',
      );
    }
  },
);

export const fetchSeatInspectionVBFlowHistory = createAsyncThunk(
  'furnishing/fetchSeatInspectionVBFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(SEAT_INSPECTION_VB_FLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);

// export const fetchLavatoryVBParams = createAsyncThunk(
//   'furnishing/fetchLavatoryVBParams',
//   async (formdata, { rejectWithValue }) => {
//     try {
//       const response = await api.post(FETCH_LAVATORY_VB_PARAMS, formdata);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
//     }
//   },
// );
export const seatInspectionActionVB = createAsyncThunk(
  'furnishing/seatInspectionActionVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to update seat inspection VB',
      );
    }
  },
);

export const addAirBrakeTestVB = createAsyncThunk(
  'furnishing/addAirBrakeTestVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_AIRBRAKE_TEST_VB, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save air brake test VB',
      );
    }
  },
);

export const fetchListAirBrakeTestVB = createAsyncThunk(
  'furnishing/fetchListAirBrakeTestVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_AIRBRAKE_TEST_VB_LIST, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch air brake test VB list',
      );
    }
  },
);

export const fetchAirBrakeTestByIdVB = createAsyncThunk(
  'furnishing/fetchAirBrakeTestByIdVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_AIRBRAKE_TEST_VB, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch air brake test VB details',
      );
    }
  },
);

export const fetchAirBrakeTestFlowHistoryVB = createAsyncThunk(
  'furnishing/fetchAirBrakeTestFlowHistoryVB',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(AIRBRAKE_TEST_VB_FLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);

export const airBrakeTestActionVB = createAsyncThunk(
  'furnishing/airBrakeTestActionVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to update air brake test VB',
      );
    }
  },
);

// ---------------- testing vb biotoilet
export const addUpdateVBbiotoilet = createAsyncThunk(
  'furnishing/addUpdateVBbiotoilet',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_UPDATE_VB_BIOTOILET, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to add/update VB biotoilet',
      );
    }
  },
);

export const getVBbiotoiletListing = createAsyncThunk(
  'furnishing/getVBbiotoiletListing',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_VB_BIOTOILET_LIST,{params});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch VB biotoilet listing',
      );
    }
  },
);

export const deleteVBbiotoilet = createAsyncThunk(
  'furnishing/deleteVBbiotoilet',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_VB_BIOTOILET}${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to delete VB biotoilet',
      );
    }
  },
);

export const updateVBbiotoiletFlowStatus = createAsyncThunk(
  'furnishing/updateVBbiotoiletFlowStatus',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_VB_BIOTOILET_FLOW_STATUS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to add/update VB biotoilet',
      );
    }
  },
);

export const getVBbiotoiletFlowHistory = createAsyncThunk(
  // listing
  'furnishing/getVBbiotoiletFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_VB_BIOTOILET_FLOW_HISTORY}${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch VB biotoilet flow history',
      );
    }
  },
);

export const viewVBbiotoiletFlowHistory = createAsyncThunk(
  'furnishing/viewVBbiotoiletFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${VIEW_VB_BIOTOILET_FLOW_HISTORY}${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch VB biotoilet flow history',
      );
    }
  },
);

export const fetchTractionParams = createAsyncThunk(
  'electrical/fetchTractionParams',
  async (coachType, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_TRACTION_PARAMS, {
        coach_type: coachType,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch traction parameters',
      );
    }
  },
);
export const checkRecordExist = createAsyncThunk(
  'furnishing/checkRecordExist ',
  async (formData, { rejectWithValue }) => {
    try {
      // console.log(1370,formData);
      const response = await api.post(CHECK_FURNISHING_RECORD_EXIST, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || ' Failed');
    }
  },
);

export const fetchBrakeEquipmentSupplier = createAsyncThunk(
  'furnishing/fetchBrakeEquipmentSupplier',
  async (params, { rejectWithValue }) => {
    try {
      console.log('Shell API Params------------------:', params);

      const response = await api.get(GET_BRAKE_EQUIPMENT_SUPPLIERS, {
        params,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
export const fetchInstalledBy = createAsyncThunk(
  'furnishing/fetchInstalledBy',
  async (params, { rejectWithValue }) => {
    try {

      const response = await api.get(GET_INSTALLED_BY, {
        params,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// partition LHB
export const fetchPartitionFlowHistoryLHB = createAsyncThunk(
  'furnishing/fetchPartitionFlowHistoryLHB',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${PARTITION_FLOW_HISTORY}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch partition flow history'
      );
    }
  }
);

// panelling flow history
export const fetchPannelingFlowHistory = createAsyncThunk(
  'furnishing/fetchPannelingFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${PANNELING_FLOW_HISTORY}${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch panelling flow history'
      );
    }
  }
);
